import { Term } from "@/app/types"
import { getAsOfLabel } from "@/app/utils"

interface AsOfDateProps {
  term: Term
  className?: string
  alternativeText?: string
}

export function AsOfDate({
  term,
  className = "",
  alternativeText,
}: AsOfDateProps) {
  return (
    <p className={`text-xs font-normal text-main-400 ${className}`}>
      {alternativeText ? alternativeText : getAsOfLabel(term)}
    </p>
  )
}
